export const fetchPaginatedExercises = async (url: string, limit: number = 10, offset: number = 0) => {
  try {
      const response = await fetch(
          `/.netlify/functions/fetchExercises?url=${encodeURIComponent(url)}&limit=${limit}&offset=${offset}`
      );

      if (!response.ok) {
          throw new Error('Failed to fetch paginated exercises');
      }

      const data = await response.json();
      return data;
  } catch (error) {
      console.error('Error fetching paginated exercises:', error);
      throw error;
  }
};